import {
	ConfigService
} from '../../';

import {
	MoreLink
} from '../'

/*& Models/Configs/More
	# MoreConfig
*/
export class MoreConfig {
	public about		= false
	public image		= ''
	public links:		MoreLink[] = []
	public login		= false
	public support	= false
	public terms		= false

	constructor(private configService: ConfigService) {}

	update(config: any) {
		if (typeof config.more === 'object') {
			let links = typeof config.more.links === 'object' ? config.more.links : this.links;
			var temp: MoreLink[] = [];

			for (var i = 0, len = links.length; i < len; i++) {
				temp.push(new MoreLink(links[i]));
			}

			this.about		= typeof config.about		=== 'object';
			this.image		= typeof config.more.image === 'string' ?
        this.configService.getImage(config.more.image) : this.image;
			this.links		= temp;
			this.login		= typeof config.login		=== 'object';
			this.support	= typeof config.support	=== 'object';
			this.terms		= typeof config.terms		=== 'object';

			this.configService.more.next(this);
		} else {
			this.about		= typeof config.about		=== 'object';
			this.login		= typeof config.login		=== 'object';
			this.support	= typeof config.support	=== 'object';
			this.terms		= typeof config.terms		=== 'object';

			this.configService.more.next(this);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/moreConfig.ts